module.exports = __webpack_public_path__ + "static/media/check.b1fd32c8.svg";